import assetPath from '/app/packages/lebenslauf/articles/src/assets/bewerbungsmappe-aufbau.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')